import { Typography } from "antd";

const SectionInfo = () => {

    return(
        <div style={{ margin: " 0 .5rem .5rem" }}>
                <Typography.Text style={{ color: "#000", fontWeight: "500" }}>
                    Note:
                </Typography.Text>{" "}
                <br />
                <Typography.Text
                    style={{ color: "#000", fontSize: ".9rem", letterSpacing: ".5px" }}
                >
                    Password protected files not allowed
                </Typography.Text>
                <br />
                <Typography.Text
                    style={{ color: "#000", fontSize: ".9rem", letterSpacing: ".5px" }}
                >
                    Maximum size 10mb
                </Typography.Text>
            </div>
    )

}

export default SectionInfo;